import React from 'react';
import PropTypes from 'prop-types';

import { useApiClient } from '../../context/ApiClientContext';

import DxHxTreeItem from './DxHxTreeItem';
import DxHxAdditionButton from './DxHxAdditionButton';
import MedicalContentTreeItem, { useMedicalContentTreeItem } from '../_common/MedicalContentTreeItem';

export default function DxHxParentTreeItem(props) {
  const {
    setFormPane,
    setTreeManagementServices,
  } = props;

  const {
    MCTreeItemLabel,
    MCTreeItemChildNodes,
    expand,
    setExpand,
    setMCTreeItemChildNodes,
  } = useMedicalContentTreeItem('DxHxs');

  const apiClient = useApiClient();

  const fetchChildNodes = async () => {
    const results = await apiClient.getAllDxHx();
    setMCTreeItemChildNodes(results.data.map((result) => (
      <DxHxTreeItem
        key={`${result.name}_${result.id}`}
        id={result.id}
        actionListIdPtFactor={result['actionListId-ptFactor']}
        setFormPane={setFormPane}
        setTreeManagementServices={setTreeManagementServices}
        label={result.name}
        refreshParent={fetchChildNodes}
      />
    )));
  };

  const reloadAndExpandNode = () => {
    fetchChildNodes();
    setExpand(true);
  };

  const onSelect = () => setFormPane(
    <DxHxAdditionButton reloadCallback={reloadAndExpandNode} />,
  );

  return (
    <MedicalContentTreeItem
      id={0}
      MCTreeItemLabel={MCTreeItemLabel}
      MCTreeItemChildNodes={MCTreeItemChildNodes}
      fetchChildNodes={fetchChildNodes}
      onSelect={onSelect}
      expand={expand}
      textToDisplayIfNoChildren="No DxHxs yet..."
    />
  );
}

DxHxParentTreeItem.propTypes = {
  setFormPane: PropTypes.func.isRequired,
  setTreeManagementServices: PropTypes.func.isRequired,
};
